import { cn } from "cn";
import { isEmpty } from "lodash-es";
import { AnimateDotBounce } from "@/components/ui/animate-dot-bounce";
import { AvatarGroup } from "@/components/ui/avatar/avatar-group";
import { Typography } from "@/components/ui/typography";

export type TypingUser = {
  name: string;
  avatarUrl?: string | null;
};

export type UserTypingProps = {
  users: TypingUser[];
  className?: string;
};

export function UserTyping({ users, className }: UserTypingProps) {
  // Nobody typing = nothing to show. Guards any caller against a bare "Typing" pill.
  if (isEmpty(users)) return null;

  return (
    <div className={cn("flex items-center gap-1", className)}>
      <AvatarGroup
        data={
          users?.map((user) => ({
            src: user.avatarUrl || "",
            name: user.name || "",
          })) || []
        }
        size="xs"
        className="px-1"
      />
      <AnimateDotBounce className="" />
      <Typography size="xs" className="text-text-dark-high">
        Typing
      </Typography>
    </div>
  );
}
